import * as complaintTypes from '../types/Complaint';
import * as apiCalls from '../api/ApiCalls';
import * as errorActions from './Error';
import * as pageActions from './Page';
import * as complaintValidator from './Validators/ComplaintValidator';

import Moment from 'moment';

export function changeComplaintType(type) {
    return{
        type: complaintTypes.COMPLAINT_CHANGE_COMPLAINT_TYPE,
        payload: {complaintType: type}
    };
}

//Create action which allows changing term of use value in store.
export function changeTermOfUseValue(value) {
    return{
        type: complaintTypes.COMPLAINT_CHANGE_TERM_OF_USE_VALUE,
        payload: {isTermOfUseAccepted: value}
    };
}


export function getComplaintById(id) {
    return async (dispatch) => {
     try {
        dispatch(getComplaintByIdRequest());
        dispatch(errorActions.clearError());
        const response = await apiCalls.GetComplaintById(id);
        const result =  await response.json();
        if(response.status===200) {
            dispatch(getComplaintByIdSuccess(result));
            return result;
        }
        else{
            return dispatch(errorActions.throwNewError("Błąd pobierania danych", result.exceptionMessage));
        }
     } catch (error) {
        return dispatch(errorActions.throwNewError("Błąd krytyczny!", "Nie można pobrać danych. Skontaktuj się z administratorem aplikacji"));
     }
    };
}

export function getComplaintByIdRequest(){
    return{
        type: complaintTypes.COMPLAINT_GET_COMPLAINT_BY_ID_REQUEST
    };
}

export function getComplaintByIdFalure(error){
    return{
        type: complaintTypes.COMPLAINT_GET_COMPLAINT_BY_ID_FAILURE,
        payload:error
    };
}

export function getComplaintByIdSuccess(complaint){
    return{
        type: complaintTypes.COMPLAINT_GET_COMPLAINT_BY_ID_SUCCESS,
        payload: complaint
    };
}

export function issueComplaint() {
    return async (dispatch,getState) => {
        dispatch(issueComplaintRequest());
        try {
            dispatch(errorActions.clearError());
            
            const positionsWithMergedFiles = getState().complaintPositions.positions.map(item => {
                item.files = [...item.files,...item.purchaseProve];
                return item;
            });

            const customer = getState().customer;
            if (customer.id === 0) {
                customer.id = null;
            }
            if (customer.surname !== "") {
                customer.name = customer.name + " " + customer.surname;
            }
            
            if (customer.phoneCode !== "") {
                customer.phone = customer.phoneCode + " " + customer.phone;
            }

            const complaintToIssue = {
                complaintHeader: getState().complaint,
                customer : customer,
                complaintPositions: positionsWithMergedFiles
            };
            const response = await apiCalls.IssueComplaint(complaintToIssue);
            const result =  await response.json();
            if(response.status===200) {
                dispatch(pageActions.changePageToPostIssueComplaint());
                return dispatch(issueComplaintSuccess());
            }
            else{
                dispatch(errorActions.throwNewError("Błąd pobierania danych", result.exceptionMessage));
                dispatch(issueComplaintFalure());
            }
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd pobierania danych", error.message));
            dispatch(issueComplaintFalure());
        }
    };
}

export function issueComplaintRequest(){
    return{
        type: complaintTypes.COMPLAINT_ISSUE_COMPLAINT_REQUEST
    };
}

export function issueComplaintFalure(){
    return{
        type: complaintTypes.COMPLAINT_ISSUE_COMPLAINT_FAILURE
    };
}

export function issueComplaintSuccess(){
    return{
        type: complaintTypes.COMPLAINT_ISSUE_COMPLAINT_SUCCESS
    };
}

export function searchComplaint(number, password) {
    return async (dispatch) => {
        try {
            dispatch(searchComplaintRequest());
            dispatch(errorActions.clearError());
            let complaintRequest = {
                number: number,
                password: password,
            };
            const response = await apiCalls.GetComplaintByNumber(complaintRequest);
            const result =  await response.json();
            if (response.status===200) {
                let complaintPosition = result.complaintPositions[0];
                complaintPosition.dateOfReceiptOfGoods = Moment(complaintPosition.dateOfReceiptOfGoods);
                complaintPosition.articlePurchaseDate = Moment(complaintPosition.articlePurchaseDate);
                complaintPosition.faultDate = Moment(complaintPosition.faultDate);
                if(complaintPosition.emails.length > 0){
                    complaintPosition.emails.map(email => {
                        email.sendingDate = Moment( email.sendingDate);
                    });
                }
                result.complaintPositions[0]=complaintPosition;
                dispatch(searchComplaintSuccess(result));
                dispatch(changeComplaintType(result.complaintHeader.complaintType));
                pageActions.changePageToComplaintPreview();
            }
            else {
                return dispatch(errorActions.throwNewError("Błąd pobierania danych", result.exceptionMessage));
            }
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd krytyczny!", "Nie można pobrać danych. Skontaktuj się z administratorem aplikacji"));
        }
    };
}

export function searchComplaintRequest(){
    return{
        type: complaintTypes.COMPLAINT_SEARCH_COMPLAINT_REQUEST
        
    };
}

export function searchComplaintFalure(error){
    return{
        type: complaintTypes.COMPLAINT_ISSUE_COMPLAINT_FAILURE,
        payload:error
    };
}

export function searchComplaintSuccess(complaint){
    return{
        type: complaintTypes.COMPLAINT_SEARCH_COMPLAINT_SUCCESS,
        payload: complaint
    };
}

export function validateComplaintType(complaintType){
    return (dispatch) => {
        try {
            dispatch(errorActions.clearError());
            complaintValidator.validateComplaintType(complaintType);
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd walidacji", error.message));
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/Complaint.js